export interface Question {
  id: string;
  selfAssessment?: string;
  externalAssessment?: string;
}

export interface SubCategory {
  name: string;
  id: string;
  questions: Question[];
}

export interface ClosedQuestion {
  id: string;
  sourceId: string;
  name: string;
  externalIntroduction?: string;
  selfIntroduction?: string;
  subCategories: SubCategory[];
}

export interface EffectQuestion {
  id: string;
  sourceId: string;
  name: string;
  questions: Question[];
}

export interface OpenQuestion {
  id: string;
  sourceId: string;
  selfAssessment: string;
  externalAssessment: string;
  suggestion: boolean;
}

export interface QuestionnaireResponse {
  name: string;
  perspective?: Perspectives;
  completed?: boolean;
  closedQuestions: ClosedQuestion[];
  openQuestions: OpenQuestion[];
  effectQuestions: EffectQuestion[];
}

export interface Answer {
  id: string;
  value: number | string;
}

export enum Perspectives {
  SELF = 'self',
  COLLEAGUE = 'colleague',
  EMPLOYEE = 'employee',
  BOSS = 'boss',
  OTHER = 'other',
}

export interface DemographicsPayload {
  branch: string;
  companySize: string;
  teamSize: string;
  managementField: string;
  teamType: string;
  customerResponsibility?: boolean;
  responsibilityField: string;
}

export interface Demographics {
  branch: string;
  companySize: string;
  teamSize: string;
  managementField: string;
  teamType: string;
  customerResponsibility: string;
  responsibilityField: string;
}
